import { render, staticRenderFns } from "./AsignaTurnosView.vue?vue&type=template&id=436c0061&scoped=true"
import script from "./AsignaTurnosView.vue?vue&type=script&lang=js"
export * from "./AsignaTurnosView.vue?vue&type=script&lang=js"
import style0 from "./AsignaTurnosView.vue?vue&type=style&index=0&id=436c0061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436c0061",
  null
  
)

export default component.exports